module.exports = __webpack_public_path__ + "static/media/gr_background_vday.fec02c67.png";